/**
 * An array of investment type options used for selection components.
 * Each option contains a `value` (the internal identifier) and a `label` (the display name).
 *
 * @type {Array<{value: string, label: string}>}
 * @example
 * // Usage in a dropdown menu:
 * InvestmentTypeOptions.map(option => (
 *   <option value={option.value}>{option.label}</option>
 * ));
 */
const InvestmentTypeOptions = [
  {
    value: "ISA",
    label: "ISA",
  },
  { value: "GIA", label: "GIA" },
];

export default InvestmentTypeOptions;
